import React from 'react';
import { PlayCircle } from 'lucide-react';
import { useDemo } from '../../contexts/DemoContext';

export const DemoModeEntry: React.FC = () => {
  const { enterDemoMode } = useDemo();

  const handleStartDemo = () => {
    enterDemoMode();
  };

  return (
    <div className="mt-6 text-center">
      <button 
        onClick={handleStartDemo}
        className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-purple-600 to-indigo-600 text-white rounded-lg font-medium hover:from-purple-700 hover:to-indigo-700 transition-all transform hover:scale-[1.02] focus:outline-none focus:ring-2 focus:ring-purple-500/50"
      >
        <PlayCircle className="w-5 h-5" />
        Try Demo Mode
      </button>
      <p className="text-white/50 text-sm mt-2">
        Explore the application safely with guided tours
      </p>
    </div>
  );
};

export default DemoModeEntry; 